

















































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class MenuIconSvg extends Vue {
  @Prop({ required: true }) public iconName: string;
  @Prop({ default: 20 }) public height: number;
  @Prop({ default: 20 }) public width: number;
  @Prop({ default: "currentColor" }) public color: string;
}
